import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import MisEntidadesView from './MisEntidadesView';

const MisEntidadesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.misEntidades} routes={[]}>
      <MisEntidadesView />
    </ContainerTemplate>
  );
};

export default MisEntidadesModule;
